/**
 * MeetingAgendaItemService
 * Service for MeetingAgendaItem entity operations
 * Route: api/meetingagendaitems
 * Controller: MeetingAgendaItemsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingAgendaItemService
 * Handles meeting agenda item CRUD operations and custom endpoints
 * Maps to /api/meetingagendaitems endpoint
 */
export class MeetingAgendaItemService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingAgendaItemService.DEFAULT_SERVICE_PATH,
            basePath: MeetingAgendaItemService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all agenda items for a meeting
     * GET /api/meetingagendaitems/meeting/{meetingId}
     * @param meetingId - Meeting ID
     * @returns Array of meeting agenda items
     */
    async getByMeeting(meetingId) {
        const response = await this.getByMeetingRaw(meetingId);
        return response.data ?? [];
    }
    getByMeetingRaw(meetingId) {
        const url = this.buildUrl('meeting/' + meetingId);
        return this.http.get(url);
    }
}
MeetingAgendaItemService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingAgendaItemService.BASE_PATH = 'api/meetingagendaitems';
//# sourceMappingURL=MeetingAgendaItemService.js.map